module.exports = __webpack_public_path__ + "static/media/calendar.cfcec46d.svg";